import { LearnerTrainingStatus } from '~/data';

interface NavigationItem {
  id: string;
  title: string;
  position: number;
  duration: number;
}

export interface Sequence extends NavigationItem {
  kind: 'sequence';
  type: string;
  chapterId: string;
  chapterSequenceId: string;
  icon?: string;
  sendRxdInteractions?: boolean;
}

export interface Chapter extends NavigationItem {
  kind: 'chapter';
  sequenceCount: number;
  icon?: string;
}

export interface Policy {
  id: string;
  name?: string;
  policyUrl?: string;
}

export interface CompanyContact {
  name?: string;
  department?: string;
  email?: string;
  phone?: string;
  otherInfo?: string;
}

export interface NavigationSlice {
  open: boolean;
  learnerTrainingId: string;
  chapterSequenceId: string;
  title: string;
  duration: number;
  regionName?: string;
  activeItemPosition: number;
  highestUnlockedPosition: number;
  items: Array<Sequence | Chapter>;
  status: LearnerTrainingStatus;
  activateSequence(id: string): void;
  unlockSequence(id: string): void;
  next(): Promise<string>;
  prev(): Promise<string>;
  toggleNav(open?: boolean): void;
  skip?: boolean;
  player?: string;
  scorePercent: number;
  lastAttemptScorePercent?: number | null;
  scorePassingPercent?: number;
  attemptStatus?: string;
  // Both null unless the company caps attempts (behind the attempt_limits flag).
  attemptLimit?: number | null;
  attemptsRemaining?: number | null;
  policy?: Policy;
  policies?: Array<Policy>;
  policiesForSignature?: Array<Policy>;
  policyAcknowledgement: boolean;
  policyAcknowledgementSignature: boolean;
  certificateUrl?: string;
  featureShowCertificate?: boolean;
  featureShowSocialShare?: boolean;
  featureShowHomeButton?: boolean;
  showDemoBanner?: boolean;
  shouldSaveVideoWatchedSeconds?: boolean;
  autoSaveVideoWatchedSecondsIntervalInSeconds?: number | null;
  companyContacts?: Array<CompanyContact>;
  shouldDisplayTimerStillRunningModal?: boolean;
  remainingDurationInMinutesForCourseTimers?: number | null;
  remainingDurationInSecondsForCourseTimers?: number | null;
  reviewTimerPaused?: boolean;
  hideTimerStillRunningModal(): void;
  getFirstChapterFirstSequenceId(): string | null;
}
